var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoReferralUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_7953)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.4438,
    y: 15.1362,
    width: 220.295,
    height: 229.669,
    rx: 56.2455,
    fill: "#E5E0E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.794 93.9232H130.906C126.277 93.9232 122.526 97.6746 122.526 102.304V123.191C122.526 127.82 126.277 131.571 130.906 131.571H151.794C156.423 131.571 160.174 127.82 160.174 123.191V102.304C160.174 97.6746 156.423 93.9232 151.794 93.9232V93.9232Z",
    fill: "#6B2B90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.748 99.0672C153.581 99.0587 155.079 100.551 155.076 102.39C155.076 104.225 153.572 105.727 151.748 105.718C149.918 105.709 148.434 104.208 148.443 102.37C148.451 100.548 149.924 99.0758 151.748 99.0672Z",
    fill: "#6B2B90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.754 111.365C148.752 109.612 150.364 108.777 152.263 108.414C152.949 108.283 153.661 108.251 154.362 108.228C155.191 108.2 155.465 108.506 155.468 109.346C155.468 109.444 155.468 109.544 155.468 109.641C155.397 111.416 155.045 113.112 153.921 114.55C152.826 115.951 151.296 116.589 149.592 116.855C148.929 116.958 148.248 116.992 147.574 116.992C147.019 116.992 146.696 116.663 146.682 116.123C146.639 114.45 146.913 112.84 147.751 111.365H147.754Z",
    fill: "#6B2B90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.297 99.4789L134.169 111.943C134.232 112.909 134.452 113.624 134.83 114.09C135.207 114.553 135.865 114.753 136.8 114.69C137.712 114.642 138.412 114.341 138.904 113.787C139.396 113.232 139.61 112.472 139.547 111.505L138.532 99.0643L142.129 98.8527L142.907 110.078C142.939 110.596 142.953 111.119 142.953 111.648C142.953 112.177 142.919 112.68 142.847 113.186C142.776 113.692 142.656 114.176 142.487 114.636C142.318 115.096 142.072 115.511 141.749 115.88C141.583 116.054 141.449 116.191 141.343 116.297C141.237 116.403 141.132 116.495 141.031 116.575C140.928 116.655 140.817 116.723 140.694 116.78C140.571 116.841 140.425 116.909 140.251 116.986C139.991 117.081 139.805 117.152 139.69 117.198C139.576 117.244 139.465 117.287 139.353 117.321C139.242 117.355 139.093 117.392 138.904 117.432C138.715 117.472 138.429 117.538 138.043 117.633C137.838 117.678 137.657 117.724 137.494 117.767C137.334 117.81 137.177 117.838 137.023 117.856C136.868 117.873 136.7 117.884 136.517 117.89C136.331 117.898 136.116 117.893 135.873 117.878C135.37 117.847 134.967 117.801 134.664 117.744C134.361 117.684 134.04 117.578 133.703 117.421C133.366 117.272 133.077 117.124 132.842 116.978C132.608 116.832 132.405 116.672 132.236 116.495C132.068 116.317 131.922 116.114 131.799 115.883C131.676 115.651 131.553 115.365 131.427 115.028C131.333 114.768 131.244 114.442 131.161 114.05C131.078 113.658 131.01 113.255 130.955 112.84C130.901 112.429 130.852 112.04 130.815 111.679C130.775 111.319 130.749 111.036 130.732 110.83L130.072 99.6848L133.291 99.4732L133.297 99.4789Z",
    fill: "#6B2B90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.468 122.319C155.434 122.413 155.402 122.508 155.365 122.602C155.099 123.271 154.613 123.688 153.893 123.703C152.423 123.734 150.95 123.717 149.481 123.711C149.14 123.711 148.94 123.5 148.917 123.16C148.906 122.985 148.917 122.811 148.917 122.593C148.431 122.593 147.96 122.588 147.485 122.605C147.436 122.605 147.368 122.742 147.348 122.828C146.896 124.569 145.872 125.842 144.251 126.625C143.493 126.991 142.687 127.143 141.846 127.143C138.858 127.143 135.87 127.154 132.882 127.137C130.043 127.12 127.833 125.287 127.318 122.519C127.215 121.964 127.241 121.384 127.233 120.818C127.227 120.552 127.427 120.355 127.693 120.309C127.81 120.289 127.93 120.295 128.05 120.295C134.246 120.295 140.442 120.295 146.639 120.295C147.345 120.295 147.482 120.429 147.482 121.127C147.482 121.235 147.482 121.344 147.482 121.493H148.915C148.915 121.31 148.909 121.138 148.915 120.969C148.926 120.572 149.138 120.352 149.532 120.349C150.956 120.343 152.383 120.337 153.807 120.352C154.556 120.36 155.156 120.832 155.394 121.544C155.414 121.601 155.442 121.658 155.465 121.716V122.322L155.468 122.319Z",
    fill: "#6B2B90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.043 115.866C168.925 116.199 172.728 117.419 176.08 119.401C177.928 126.255 180.058 133.764 180.929 140.808C179.022 142.303 176.648 142.504 174.29 141.928C167.512 140.258 161.399 136.057 157.437 130.345C154.133 125.589 160.204 119.063 165.043 115.871V115.866Z",
    fill: "#EDD28B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.144 106.56C172.027 106.893 175.83 108.114 179.181 110.095C181.03 116.949 183.159 124.458 184.031 131.502C182.124 132.998 179.75 133.198 177.391 132.622C170.614 130.953 164.501 126.751 160.538 121.039C157.235 116.283 163.306 109.757 168.144 106.565V106.56Z",
    fill: "#EDD28B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9404 272.272C37.0597 285.906 49.8229 295.936 63.2819 299.259C76.7409 302.583 91.4747 303.455 105.189 301.421C111.212 279.845 116.343 256.483 117.83 234.135C103.048 227.656 87.5496 221.532 71.7695 218.113C59.2931 232.629 48.835 248.868 40.7989 266.216C39.7738 268.436 36.4754 270.37 34.9404 272.272Z",
    fill: "#DB83F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M117.83 234.135C103.048 227.656 87.5494 221.532 71.7693 218.113C67.2971 223.318 63.0905 228.745 59.1548 234.362C71.8171 234.531 84.4316 238.901 94.3267 246.791C102.565 253.359 108.827 262.295 112.38 272.177C115.02 259.505 117.001 246.664 117.835 234.135H117.83Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.245 93.3544C152.348 85.655 167.241 80.9889 182.411 79.8264C185.428 79.5939 189.268 80.0219 190.224 82.8755C191.228 85.877 188.094 88.5456 185.327 90.1098C172.117 97.5818 157.819 103.141 143.016 106.56C139.691 103.067 139.187 98.1631 139.24 93.3544H139.245Z",
    fill: "#EDD28B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.179 97.2542C173.838 100.266 180.791 105.054 186.325 111.126C185.55 112.293 184.318 113.683 183.075 114.333C177.434 117.287 170.598 115.58 164.979 112.579C163.109 111.58 162.722 109.07 162.148 107.036C161.67 105.334 161.442 103.5 161.962 101.815C162.483 100.129 164.421 97.4867 166.185 97.2489L166.179 97.2542Z",
    fill: "#EDD28B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M168.681 132.77C171.267 143.36 167.098 154.574 160.799 163.488C154.499 172.403 146.166 179.674 138.958 187.876C131.746 196.077 125.446 205.779 124.581 216.644C119.343 219.159 113.081 221.363 107.605 219.418C102.129 217.473 97.4978 213.278 95.0439 208.036C96.5258 191.95 100.069 175.896 106.559 161.095C113.05 146.293 123.959 132.892 138.698 126.117C143.638 123.85 149.114 122.339 154.505 123.052C159.896 123.771 167.395 127.507 168.686 132.765L168.681 132.77Z",
    fill: "#EDD28B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M156.205 169.359C155.992 168.947 155.758 168.567 155.509 168.244C153.868 166.125 151.377 164.836 148.886 163.821C142.714 161.316 135.905 160.117 129.313 161.116C122.722 162.109 116.38 165.428 112.37 170.728C108.36 176.028 107.924 183.976 110.32 190.169C121.728 182.248 135.411 177.635 149.3 176.916C151.669 174.448 154 171.954 156.21 169.365L156.205 169.359Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.842 52.3001H120.055C113.992 52.3001 109.077 57.1904 109.077 63.2229V162.41C109.077 168.443 113.992 173.333 120.055 173.333H163.842C169.906 173.333 174.821 168.443 174.821 162.41V63.2229C174.821 57.1904 169.906 52.3001 163.842 52.3001Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.842 55.6979H157.378V57.3255C157.378 59.4974 155.599 61.2677 153.416 61.2677H130.481C128.298 61.2677 126.519 59.4974 126.519 57.3255V55.6979H120.055C115.886 55.6979 112.492 59.0746 112.492 63.2229V162.41C112.492 166.559 115.886 169.935 120.055 169.935H163.842C168.012 169.935 171.405 166.559 171.405 162.41V63.2229C171.405 59.0746 168.012 55.6979 163.842 55.6979Z",
    fill: "#FFCC64"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.842 55.6979H157.378V57.3255C157.378 59.4974 155.599 61.2677 153.416 61.2677H130.481C128.298 61.2677 126.519 59.4974 126.519 57.3255V55.6979H120.055C115.886 55.6979 112.492 59.0746 112.492 63.2229V162.41C112.492 166.559 115.886 169.935 120.055 169.935H163.842C168.012 169.935 171.405 166.559 171.405 162.41V63.2229C171.405 59.0746 168.012 55.6979 163.842 55.6979Z",
    fill: "#6B2B90"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.443 153.374C119.11 147.762 115.997 142.626 115.174 136.919C114.346 131.159 115.918 125.351 117.421 119.729C118.924 114.106 120.39 108.251 119.344 102.523C118.642 98.6915 116.008 94.0941 112.598 91.2828C111.525 90.3951 110.155 90.3581 109.077 90.8918V162.416C109.077 168.091 113.432 172.757 118.998 173.286C121.033 166.728 122.01 159.99 120.443 153.385V153.374Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2407 208.247C81.1972 200.22 86.3173 189.461 87.5177 178.253C88.4897 169.137 86.9441 159.916 87.6452 150.774C88.5162 139.429 92.7919 128.664 96.324 117.842C99.3408 108.6 101.858 98.8659 101.226 89.2537C101.051 86.5798 104.089 84.8835 106.309 86.4054C109.958 88.9102 112.991 93.2592 114.027 97.0111C115.572 102.623 114.638 108.584 113.634 114.317C112.635 120.051 111.584 125.969 112.917 131.64C114.239 137.252 117.798 142.097 119.62 147.572C123.13 158.114 119.891 169.608 116.263 180.108C112.63 190.613 108.54 201.594 110.431 212.538C104.53 216.549 98.1882 220.634 91.0444 220.348C83.9007 220.063 75.8167 214.874 73.2407 208.242V208.247Z",
    fill: "#EDD28B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8273 195.86C94.6721 196.605 113.304 202.228 129.382 212.031C127.81 221.31 125.112 234.637 119.997 242.553C97.6517 240.767 80.018 235.023 61.9009 221.881C64.1529 212.363 70.4841 203.607 75.8273 195.86Z",
    fill: "#DB83F2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M177.375 103.273C176.6 105.234 176.196 107.331 176.196 109.435C176.196 110.777 177.8 111.353 179.07 111.813C180.977 112.51 183.027 112.811 185.056 112.716C185.539 112.193 185.975 111.633 186.32 111.115C183.643 108.177 180.631 105.545 177.375 103.268V103.273Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M177.152 124.146C177.333 126.26 177.652 129.166 178.56 131.085C178.873 131.745 179.288 132.369 179.787 132.913C181.311 132.902 182.772 132.485 184.031 131.497C183.632 128.289 182.968 124.986 182.198 121.694C180.445 122.35 178.751 123.163 177.158 124.141L177.152 124.146Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M106.447 98.9557C106.596 94.649 104.817 90.3264 101.747 87.2932C101.38 87.8374 101.173 88.5033 101.221 89.2536C101.46 92.921 101.242 96.6042 100.716 100.272C102.708 100.504 104.822 100.044 106.442 98.9557H106.447Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.245 186.037C110.171 186.037 110.091 186.021 110.017 185.984C109.751 185.857 109.64 185.545 109.767 185.281C115.631 173.053 116.119 158.241 111.079 145.654C110.967 145.384 111.1 145.078 111.376 144.967C111.647 144.856 111.955 144.988 112.067 145.263C117.219 158.114 116.72 173.249 110.728 185.736C110.638 185.926 110.447 186.037 110.25 186.037H110.245Z",
    fill: "#A59CF9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M125.531 199.729C125.473 199.729 125.409 199.718 125.351 199.697C125.074 199.596 124.931 199.295 125.032 199.02C127.741 191.58 132.776 184.922 139.208 180.266C139.447 180.097 139.776 180.145 139.951 180.382C140.127 180.62 140.074 180.948 139.835 181.122C133.573 185.656 128.67 192.14 126.03 199.38C125.951 199.596 125.749 199.729 125.531 199.729Z",
    fill: "#A59CF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.2132 216.036C92.2397 215.93 92.261 215.825 92.2875 215.714C92.5903 214.372 92.3353 212.855 91.2677 211.883C90.4923 211.174 89.5415 210.731 88.4686 210.731C87.4542 210.731 86.3866 211.169 85.6695 211.883C84.6338 212.913 84.3364 214.324 84.6498 215.714C84.6763 215.819 84.6976 215.925 84.7241 216.036C84.8569 216.343 84.9844 216.649 85.1172 216.961C85.3615 217.41 85.6961 217.775 86.1157 218.044C86.36 218.282 86.6415 218.451 86.9708 218.541C87.4329 218.784 87.9322 218.895 88.4686 218.874C89.1591 218.842 89.8177 218.668 90.4285 218.345C90.88 218.102 91.2465 217.769 91.5174 217.352C91.8626 216.977 92.091 216.538 92.2132 216.036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.206 224.845C106.804 224.845 106.804 220.834 104.206 220.834C101.609 220.834 101.609 224.845 104.206 224.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1037 229.39C89.8603 229.39 89.8656 225.13 87.1037 225.13C84.3417 225.13 84.3417 229.39 87.1037 229.39Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.386 235.794C108.567 235.752 108.694 235.694 108.885 235.615C109.22 235.477 109.597 235.271 109.831 234.986C110.102 234.737 110.288 234.442 110.399 234.103C110.574 233.776 110.649 233.422 110.638 233.046C110.606 232.803 110.574 232.56 110.537 232.317C110.404 231.852 110.171 231.451 109.831 231.107C109.496 230.695 108.907 230.42 108.386 230.299C107.414 230.071 106.299 230.272 105.603 231.033C105.088 231.588 104.764 232.275 104.764 233.046C104.764 233.776 105.082 234.542 105.603 235.06C106.346 235.8 107.382 236.032 108.386 235.794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.975 224.591C124.676 222.79 123.03 220.697 121.128 220.829C120.555 220.871 120.061 221.014 119.604 221.368C119.147 221.722 118.903 222.124 118.701 222.668C118.701 222.684 118.69 222.694 118.685 222.71L118.945 222.097C118.929 222.134 118.908 222.161 118.887 222.192C119.03 222.007 119.174 221.822 119.317 221.638C118.818 222.208 118.441 222.89 118.473 223.677C118.489 224.074 118.568 224.433 118.717 224.792C118.786 224.956 118.85 225.093 118.919 225.247C119.062 225.432 119.206 225.617 119.349 225.802C119.535 225.944 119.721 226.087 119.907 226.23C120.443 226.541 121.059 226.637 121.67 226.557C122.169 226.489 122.578 226.319 122.977 226.018C123.184 225.897 123.348 225.733 123.471 225.527C123.715 225.263 123.88 224.951 123.965 224.591H123.975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.682 214.002C112.343 214.002 112.349 209.89 109.682 209.89C107.016 209.89 107.016 214.002 109.682 214.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4111 203.644C91.358 203.702 91.2996 203.761 91.2465 203.819C90.7206 204.374 90.7153 205.219 91.2465 205.779C91.2996 205.837 91.358 205.895 91.4111 205.954C91.8626 206.429 92.6168 206.54 93.2064 206.292C93.78 206.049 94.2474 205.446 94.2155 204.796C94.189 204.226 93.9075 203.681 93.4029 203.385C92.7868 203.026 91.9104 203.116 91.4111 203.639V203.644Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3945 210.25C78.0318 210.25 78.7011 209.975 79.1525 209.526C79.5828 209.098 79.9068 208.395 79.8802 207.777C79.8536 207.137 79.6412 206.477 79.1525 206.027C78.6692 205.584 78.069 205.304 77.3945 205.304C76.7571 205.304 76.0879 205.578 75.6364 206.027C75.2062 206.456 74.8822 207.158 74.9087 207.777C74.9353 208.416 75.1478 209.077 75.6364 209.526C76.1197 209.97 76.7199 210.25 77.3945 210.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0761 220.512C75.3494 220.512 75.3547 216.993 73.0761 216.993C70.7975 216.993 70.7975 220.512 73.0761 220.512Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9051 246.062C62.9051 246.062 62.9476 246.083 62.9689 246.094C63.909 246.569 64.9606 246.638 65.9007 246.094C66.7824 245.581 67.3401 244.619 67.3401 243.599C67.3401 242.579 66.7877 241.618 65.9007 241.105C64.9606 240.561 63.9143 240.63 62.9689 241.105C62.9476 241.116 62.9264 241.126 62.9051 241.137C61.0355 242.077 61.0355 245.121 62.9051 246.057V246.062Z",
    fill: "black"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0269 118.973H56.8285C55.1926 118.973 53.8647 117.652 53.8647 116.024V107.638C53.8647 106.01 55.1926 104.689 56.8285 104.689H63.0269V118.968V118.973Z",
    fill: "#957DB5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.0269 118.973H56.8285C55.1926 118.973 53.8647 117.652 53.8647 116.024V107.638C53.8647 106.01 55.1926 104.689 56.8285 104.689H63.0269V118.968V118.973Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5793 105.799C64.1688 104.547 65.5126 103.817 66.8404 103.405C68.1683 102.993 69.5758 102.808 70.8346 102.216C73.4637 100.985 75.0784 97.9147 74.5951 95.0664C75.7317 94.5063 77.6491 94.8339 78.4458 95.8115C79.2425 96.7892 79.5028 98.0997 79.5824 99.3626C79.6621 100.62 79.5824 101.899 79.8108 103.141C80.9315 102.47 82.8489 103.654 83.7678 104.578C84.6814 105.503 85.0425 106.866 85.0107 108.161C84.9788 109.456 84.6017 110.724 84.2299 111.966C83.1304 115.617 80.2464 119.544 76.6134 120.743C72.9804 121.943 68.7472 121.139 65.81 118.698C65.024 118.043 63.813 117.477 63.5102 116.505C63.2075 115.533 63.1915 114.497 63.1968 113.477C63.2128 111.242 62.6338 107.818 63.5899 105.794L63.5793 105.799Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M81.139 71.2604C84.6004 71.2604 87.4064 68.4687 87.4064 65.0249C87.4064 61.5811 84.6004 58.7893 81.139 58.7893C77.6776 58.7893 74.8716 61.5811 74.8716 65.0249C74.8716 68.4687 77.6776 71.2604 81.139 71.2604Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0456 89.6288C95.1397 89.6288 96.0267 88.7464 96.0267 87.6578C96.0267 86.5692 95.1397 85.6867 94.0456 85.6867C92.9514 85.6867 92.0645 86.5692 92.0645 87.6578C92.0645 88.7464 92.9514 89.6288 94.0456 89.6288Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2925 161.332C65.2109 161.332 66.7661 159.785 66.7661 157.876C66.7661 155.968 65.2109 154.42 63.2925 154.42C61.374 154.42 59.8188 155.968 59.8188 157.876C59.8188 159.785 61.374 161.332 63.2925 161.332Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M208.814 174.818C210.477 174.818 211.825 173.477 211.825 171.822C211.825 170.167 210.477 168.826 208.814 168.826C207.151 168.826 205.802 170.167 205.802 171.822C205.802 173.477 207.151 174.818 208.814 174.818Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M216.212 105.429C216.212 106.999 214.932 108.272 213.355 108.272C211.777 108.272 210.497 106.999 210.497 105.429C210.497 103.86 211.777 102.586 213.355 102.586C214.932 102.586 216.212 103.86 216.212 105.429Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M159.306 31.2314C161.548 31.2314 163.364 29.4238 163.364 27.1941C163.364 24.9644 161.548 23.1569 159.306 23.1569C157.065 23.1569 155.249 24.9644 155.249 27.1941C155.249 29.4238 157.065 31.2314 159.306 31.2314Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M202.299 56.8389C204.91 56.8389 207.026 54.7333 207.026 52.1358C207.026 49.5384 204.91 47.4327 202.299 47.4327C199.688 47.4327 197.572 49.5384 197.572 52.1358C197.572 54.7333 199.688 56.8389 202.299 56.8389Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M233.096 136.574C234.812 134.868 234.812 132.101 233.096 130.394C231.381 128.687 228.6 128.687 226.884 130.394C225.169 132.101 225.169 134.868 226.884 136.574C228.6 138.281 231.381 138.281 233.096 136.574Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M246.858 218.359C246.858 219.929 245.578 221.202 244 221.202C242.423 221.202 241.143 219.929 241.143 218.359C241.143 216.79 242.423 215.516 244 215.516C245.578 215.516 246.858 216.79 246.858 218.359Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M172.523 247.361C174.932 247.361 176.884 245.419 176.884 243.023C176.884 240.627 174.932 238.684 172.523 238.684C170.115 238.684 168.163 240.627 168.163 243.023C168.163 245.419 170.115 247.361 172.523 247.361Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M153.581 219.085C155.845 219.085 157.681 217.259 157.681 215.006C157.681 212.753 155.845 210.926 153.581 210.926C151.316 210.926 149.48 212.753 149.48 215.006C149.48 217.259 151.316 219.085 153.581 219.085Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M150.124 104.045C151.448 104.039 152.53 105.117 152.528 106.445C152.528 107.771 151.442 108.855 150.124 108.849C148.803 108.842 147.731 107.758 147.737 106.43C147.744 105.115 148.807 104.052 150.124 104.045Z",
    fill: "#FFCC33"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M147.24 112.927C147.961 111.661 149.125 111.058 150.496 110.796C150.992 110.701 151.506 110.678 152.012 110.662C152.611 110.641 152.809 110.862 152.811 111.469C152.811 111.539 152.811 111.611 152.811 111.682C152.759 112.964 152.505 114.189 151.694 115.227C150.903 116.239 149.798 116.7 148.568 116.892C148.089 116.966 147.597 116.991 147.11 116.991C146.709 116.991 146.476 116.753 146.465 116.363C146.435 115.155 146.633 113.992 147.238 112.927H147.24Z",
    fill: "#FFCC33"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.799 104.343L137.429 113.344C137.475 114.042 137.634 114.558 137.906 114.895C138.179 115.229 138.654 115.374 139.329 115.328C139.988 115.293 140.494 115.076 140.849 114.676C141.204 114.275 141.359 113.726 141.313 113.028L140.58 104.043L143.178 103.891L143.74 111.998C143.762 112.371 143.773 112.749 143.773 113.131C143.773 113.513 143.748 113.877 143.696 114.242C143.645 114.608 143.558 114.957 143.436 115.289C143.314 115.622 143.137 115.921 142.903 116.187C142.784 116.313 142.687 116.412 142.61 116.489C142.534 116.565 142.457 116.631 142.385 116.689C142.311 116.747 142.23 116.797 142.142 116.838C142.053 116.881 141.947 116.931 141.821 116.986C141.634 117.055 141.499 117.106 141.417 117.139C141.334 117.172 141.254 117.203 141.173 117.228C141.093 117.253 140.985 117.28 140.849 117.309C140.713 117.338 140.506 117.385 140.227 117.453C140.079 117.486 139.949 117.519 139.831 117.55C139.715 117.581 139.602 117.602 139.49 117.614C139.379 117.627 139.257 117.635 139.125 117.639C138.99 117.645 138.836 117.641 138.66 117.631C138.297 117.608 138.005 117.575 137.787 117.534C137.568 117.49 137.336 117.414 137.093 117.3C136.849 117.193 136.64 117.086 136.471 116.98C136.302 116.875 136.155 116.759 136.033 116.631C135.912 116.503 135.806 116.357 135.717 116.189C135.629 116.022 135.54 115.816 135.449 115.572C135.381 115.384 135.317 115.149 135.257 114.866C135.197 114.583 135.148 114.292 135.108 113.992C135.069 113.695 135.034 113.414 135.007 113.154C134.978 112.894 134.96 112.689 134.947 112.541L134.47 104.491L136.795 104.339L136.799 104.343Z",
    fill: "#FFCC33"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M152.811 120.838C152.786 120.906 152.763 120.974 152.737 121.042C152.545 121.525 152.193 121.827 151.673 121.837C150.612 121.86 149.548 121.847 148.487 121.843C148.241 121.843 148.097 121.69 148.08 121.445C148.072 121.319 148.08 121.193 148.08 121.036C147.729 121.036 147.388 121.032 147.046 121.044C147.01 121.044 146.961 121.143 146.946 121.205C146.62 122.463 145.881 123.382 144.71 123.947C144.163 124.212 143.581 124.321 142.973 124.321C140.816 124.321 138.658 124.329 136.5 124.317C134.449 124.305 132.853 122.981 132.481 120.982C132.407 120.582 132.426 120.162 132.42 119.753C132.415 119.561 132.56 119.419 132.752 119.386C132.837 119.371 132.923 119.376 133.01 119.376C137.485 119.376 141.96 119.376 146.434 119.376C146.944 119.376 147.044 119.473 147.044 119.977C147.044 120.055 147.044 120.133 147.044 120.241H148.078C148.078 120.109 148.074 119.985 148.078 119.863C148.086 119.576 148.239 119.417 148.524 119.415C149.552 119.411 150.583 119.407 151.611 119.417C152.152 119.423 152.586 119.764 152.757 120.278C152.772 120.319 152.792 120.361 152.809 120.402V120.84L152.811 120.838Z",
    fill: "#FFCC33"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_526_7953)"
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2725 195.977C34.6587 188.991 40.0264 181.601 38.2539 179.481L33.9597 174.316L3.58559 199.606L7.8798 204.771C9.64668 206.899 17.8863 202.963 26.2725 195.977Z",
    fill: "url(#paint0_linear_526_7953)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9513 174.308C32.1805 172.182 23.9471 176.12 15.5613 183.104C7.1756 190.088 1.81309 197.473 3.58383 199.599C5.35457 201.726 13.588 197.787 21.9738 190.803C30.3595 183.819 35.722 176.434 33.9513 174.308Z",
    fill: "url(#paint1_linear_526_7953)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M21.8389 190.644C13.5087 197.583 5.35469 201.554 3.55007 199.569C3.56658 199.58 3.56919 199.594 3.58006 199.614C5.34693 201.743 13.5865 197.806 21.9728 190.82C30.359 183.835 35.7266 176.444 33.9541 174.324C33.9376 174.313 33.9211 174.301 33.9185 174.288C35.5494 176.42 30.1717 183.719 21.8359 190.666L21.8389 190.644Z",
    fill: "url(#paint2_linear_526_7953)"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2555 177.386C28.9159 175.778 22.6868 178.758 16.3423 184.042C9.99786 189.325 5.94057 194.913 7.28011 196.521C8.61965 198.13 14.8488 195.15 21.1932 189.866C27.5377 184.582 31.595 178.995 30.2555 177.386Z",
    fill: "url(#paint3_linear_526_7953)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M30.3225 177.474C28.8386 176.048 22.7184 179.01 16.4778 184.205C10.2455 189.404 6.21202 194.896 7.35412 196.61C7.7491 196.989 8.4667 197.056 9.42877 196.853C10.4513 194.33 13.8428 190.362 18.4281 186.543C23.0133 182.725 27.5373 180.112 30.2037 179.561C30.5722 178.65 30.6389 177.933 30.3364 177.471L30.3225 177.474Z",
    fill: "url(#paint4_linear_526_7953)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21456 196.901C10.1315 194.39 13.5799 190.303 18.2968 186.381C23.0136 182.459 27.6518 179.803 30.2809 179.36C30.599 178.487 30.6153 177.808 30.2707 177.39C28.9249 175.78 22.6992 178.755 16.3548 184.048C10.0021 189.335 5.95088 194.924 7.28842 196.529C7.63302 196.946 8.30851 197.056 9.2202 196.892L9.21456 196.901Z",
    fill: "#99570E"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_526_7953)"
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M244.093 200.457C251.734 194.092 256.624 187.36 255.009 185.428L251.097 180.722L223.424 203.763L227.337 208.468C228.946 210.408 236.453 206.821 244.093 200.457Z",
    fill: "url(#paint5_linear_526_7953)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M251.089 180.715C249.476 178.778 241.975 182.366 234.335 188.729C226.695 195.092 221.809 201.82 223.423 203.757C225.036 205.694 232.537 202.106 240.177 195.744C247.817 189.381 252.702 182.652 251.089 180.715Z",
    fill: "url(#paint6_linear_526_7953)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M240.054 195.598C232.465 201.92 225.036 205.538 223.392 203.73C223.407 203.74 223.409 203.753 223.419 203.77C225.029 205.71 232.536 202.123 240.176 195.759C247.816 189.394 252.707 182.662 251.092 180.73C251.077 180.72 251.062 180.709 251.059 180.697C252.545 182.64 247.646 189.289 240.051 195.618L240.054 195.598Z",
    fill: "url(#paint7_linear_526_7953)"
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M247.722 183.52C246.501 182.054 240.826 184.769 235.046 189.583C229.266 194.397 225.569 199.487 226.79 200.953C228.01 202.418 233.685 199.703 239.465 194.889C245.246 190.075 248.942 184.985 247.722 183.52Z",
    fill: "url(#paint8_linear_526_7953)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M247.783 183.6C246.431 182.3 240.855 184.999 235.17 189.731C229.492 194.469 225.817 199.472 226.858 201.033C227.217 201.379 227.871 201.439 228.748 201.255C229.679 198.956 232.769 195.341 236.947 191.862C241.124 188.384 245.246 186.003 247.675 185.501C248.011 184.671 248.071 184.017 247.796 183.597L247.783 183.6Z",
    fill: "url(#paint9_linear_526_7953)"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M228.553 201.298C229.388 199.011 232.53 195.288 236.827 191.714C241.124 188.141 245.35 185.722 247.745 185.318C248.035 184.522 248.05 183.903 247.736 183.523C246.51 182.056 240.838 184.767 235.058 189.589C229.27 194.406 225.579 199.497 226.798 200.959C227.112 201.34 227.727 201.44 228.558 201.291L228.553 201.298Z",
    fill: "#99570E"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_526_7953)",
    filter: "url(#filter0_f_526_7953)"
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M44.71 32.9706C36.1782 20.6473 26.7323 12.408 23.6015 14.5664L16.0133 19.816L46.902 64.4584L54.4902 59.2088C57.6135 57.0426 53.234 45.3012 44.71 32.9706Z",
    fill: "url(#paint10_linear_526_7953)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8043 46.0566C34.3322 58.3849 43.7789 66.6265 46.9041 64.4647C50.0292 62.303 45.6494 50.5564 37.1214 38.2281C28.5934 25.8998 19.1467 17.6582 16.0216 19.82C12.8965 21.9818 17.2763 33.7283 25.8043 46.0566Z",
    fill: "url(#paint11_linear_526_7953)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M36.8751 38.3891C45.348 50.6351 49.7754 62.2714 46.8329 64.4949C46.856 64.4802 46.8789 64.4732 46.8944 64.4583C50.0177 62.2922 45.6383 50.5508 37.1142 38.2201C28.5826 25.8893 19.1367 17.65 16.0134 19.8161C15.9903 19.8308 15.9747 19.8456 15.9516 19.8602C19.0704 17.8913 28.4022 26.1431 36.8751 38.3891Z",
    fill: "url(#paint12_linear_526_7953)"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1767 45.1072C33.6286 54.4344 40.7779 60.6682 43.145 59.0308C45.5122 57.3933 42.2007 48.5048 35.7487 39.1776C29.2968 29.8504 22.1475 23.6166 19.7804 25.254C17.4132 26.8914 20.7247 35.78 27.1767 45.1072Z",
    fill: "url(#paint13_linear_526_7953)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M19.9036 25.1722C17.7665 27.0197 21.0771 35.7695 27.4209 44.931C33.7646 54.1 40.7769 60.2798 43.2666 58.9336C43.8318 58.4459 44.0139 57.4637 43.8628 56.1247C40.5409 54.4163 35.515 49.2919 30.8601 42.5597C26.1977 35.8274 23.1766 29.3228 22.7466 25.6099C21.5468 24.9902 20.5644 24.8157 19.9112 25.1724L19.9036 25.1722Z",
    fill: "url(#paint14_linear_526_7953)"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8858 56.4288C40.5681 54.8647 35.4002 49.6459 30.613 42.7285C25.8261 35.8036 22.7633 29.1311 22.4686 25.4745C21.3126 24.9317 20.3893 24.8269 19.78 25.2529C17.4126 26.8901 20.7276 35.7766 27.1813 45.1076C33.635 54.4385 40.7828 60.6669 43.1502 59.0296C43.7595 58.6036 43.993 57.6985 43.8934 56.429L43.8858 56.4288Z",
    fill: "#99570E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_526_7953",
    x: 4.04004,
    y: 4,
    width: 62.4238,
    height: 71.0249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_526_7953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_526_7953",
    x1: 37.63,
    y1: 178.725,
    x2: 7.25487,
    y2: 204.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_526_7953",
    x1: 15.0942,
    y1: 182.543,
    x2: 21.7306,
    y2: 190.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_526_7953",
    x1: 35.467,
    y1: 176.128,
    x2: 5.09191,
    y2: 201.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_526_7953",
    x1: 15.9648,
    y1: 183.588,
    x2: 21.6476,
    y2: 190.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_526_7953",
    x1: 29.5567,
    y1: 176.548,
    x2: 6.58131,
    y2: 195.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_526_7953",
    x1: 254.441,
    y1: 184.74,
    x2: 226.767,
    y2: 207.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_526_7953",
    x1: 233.909,
    y1: 188.218,
    x2: 239.955,
    y2: 195.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_526_7953",
    x1: 252.47,
    y1: 182.373,
    x2: 224.796,
    y2: 205.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_526_7953",
    x1: 234.702,
    y1: 189.17,
    x2: 239.879,
    y2: 195.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_526_7953",
    x1: 247.085,
    y1: 182.756,
    x2: 226.154,
    y2: 200.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_526_7953",
    x1: 22.6321,
    y1: 15.1091,
    x2: 53.5145,
    y2: 59.7538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6C440F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFEB65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D87F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FFD66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_526_7953",
    x1: 24.9745,
    y1: 46.6306,
    x2: 36.6785,
    y2: 38.5345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_526_7953",
    x1: 18.8077,
    y1: 17.7547,
    x2: 49.6902,
    y2: 62.3994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_526_7953",
    x1: 26.5029,
    y1: 45.5733,
    x2: 36.5411,
    y2: 38.6295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_526_7953",
    x1: 18.672,
    y1: 25.8921,
    x2: 42.028,
    y2: 59.6564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF984D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_7953"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.4438,
    y: 15.1362,
    width: 220.295,
    height: 229.669,
    rx: 56.2455,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_526_7953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.96,
    height: 20.94,
    fill: "white",
    transform: "translate(1 200.127) rotate(-55.639)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_526_7953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4059,
    height: 19.0776,
    fill: "white",
    transform: "translate(221.068 204.238) rotate(-55.639)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_526_7953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.0825,
    height: 41.2752,
    fill: "white",
    transform: "translate(56.4639 14.9558) rotate(91.3269)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReferralUsers);
export default __webpack_public_path__ + "static/media/no-referral-users.71f18130315d0ce22872065c63a30627.svg";
export { ForwardRef as ReactComponent };